import React from "react";
import ResultComponent from "../components/ResultComponet";

export default props => <ResultComponent {...props} />;



// WEBPACK FOOTER //
// ./src/pages/status.js